import { Deserializable } from './deserializable.model';

export class Showings implements Deserializable<Showings> {
  count?: number | null;
  notes?: string | null;
  displayOnClientReport?: boolean;

  constructor(input?: Partial<Showings>) {
    this.deserialize(input || {});
  }

  deserialize(input: any): Showings {
    Object.assign(this, input);
    return this;
  }
}
